import { render, staticRenderFns } from "./laporan_dhr_urut_noFormulir.vue?vue&type=template&id=53cd36d3&"
import script from "./laporan_dhr_urut_noFormulir.vue?vue&type=script&lang=js&"
export * from "./laporan_dhr_urut_noFormulir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports